import { css, styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'headerCell' && prop !== 'denseCells',
})<{
  active?: boolean;
  headerCell?: boolean;
  denseCells?: boolean;
}>`
  position: relative;
  height: 30px;
  max-width: unset !important;
  padding-left: 0px;

  ${({ denseCells, theme }) =>
    denseCells &&
    css`
      max-height: ${theme.spacing(3)};
      &:first-of-type {
        margin-top: ${theme.spacing(1)};
      }
    `}

  ${({ headerCell }) =>
    headerCell &&
    css`
      cursor: pointer;
    `}

  ${({ active, theme }) =>
    active &&
    css`
      color: ${theme.palette.primary.main};
    `}
`;
